const UTMLimitedClassList = [
  'page-bs-core-result-',
  'page-bs-core',
  'page-stockist',
  'page-shade-finder-store',
  'page-bst-result-',
]

const isUTMLimitedPage = () => {
  return UTMLimitedClassList.some(className => {
    return ($(`[class^="${className}"]`).length) ? true : false;
  });
} 

const hideUTMLimitedElements = () => {
  $('body').addClass('utm-limited-elements--hidden');
}

const UTMSourceHandlerInit = () => {
  if(localStorage.getItem('UTM_SOURCE') == 'in-store'){
    if(isUTMLimitedPage()) {
      hideUTMLimitedElements();
    }
  }
}

UTMSourceHandlerInit();